import { render, staticRenderFns } from "./EngineeringModulesHeader.vue?vue&type=template&id=4e48d7bd&scoped=true&"
import script from "./EngineeringModulesHeader.vue?vue&type=script&lang=js&"
export * from "./EngineeringModulesHeader.vue?vue&type=script&lang=js&"
import style0 from "./EngineeringModulesHeader.vue?vue&type=style&index=0&id=4e48d7bd&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e48d7bd",
  null
  
)

export default component.exports